import { render, staticRenderFns } from "./indexCsgAdmin.vue?vue&type=template&id=9a79ca48&scoped=true"
import script from "./indexCsgAdmin.vue?vue&type=script&lang=js"
export * from "./indexCsgAdmin.vue?vue&type=script&lang=js"
import style0 from "./indexCsgAdmin.vue?vue&type=style&index=0&id=9a79ca48&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a79ca48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a79ca48')) {
      api.createRecord('9a79ca48', component.options)
    } else {
      api.reload('9a79ca48', component.options)
    }
    module.hot.accept("./indexCsgAdmin.vue?vue&type=template&id=9a79ca48&scoped=true", function () {
      api.rerender('9a79ca48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/channel/online/flowdistribution/indexCsgAdmin.vue"
export default component.exports